import React from 'react';
import Hint from '../Hint/Hint';
import Select from '../e-select/Select';
import Input from '../e-input/Input';
import CheckBox from '../e-checkbox/CheckBox';
import {observer, inject} from 'mobx-react';
import './SettingsField.scss';

const SettingsField = inject("AllInputsStore", "mainStore", "CookieStore")(observer((props) => {
    const store = props.AllInputsStore;
    const input = store.inputByName(props.name);
    let {value, name, required, type, label, hint, values, pattern, isValid} = input;
    const settingsFieldBaseClass = 'settings-field';

    const getInputFieldClass = () => {
        let inputFieldClass = settingsFieldBaseClass;
        if (type === 'checkbox') {
            inputFieldClass += ` ${inputFieldClass}_type_checkbox`;
        }
        return inputFieldClass;
    };

    const getInputBoxClass = () => {
        let inputBoxClass = `${settingsFieldBaseClass}__input-box`;
        if (type === 'checkbox') {
            inputBoxClass += ` ${settingsFieldBaseClass}__input-box_type_checkbox`;
        }
        return inputBoxClass;
    }

    const renderInput = () => {
        switch (type) {
            case 'input':
                return <Input
                    name={name}
                    value={value}
                    onChange={store.handleChange}
                    label={label}
                    required={required}
                    patternStr={pattern}
                    isValid={isValid}
                />
            case 'select':
                return <Select
                    values={values}
                    name={name}
                    value={value}
                    onChange={store.handleChange}
                    label={label}
                    required={required}
                />;
            case 'checkbox':
                return <CheckBox
                    label={label}
                    value={value}
                    onChange={store.handleChange}
                    className="input-field"
                    name={name}
                    id={name}
                    required={required} type="text"
                />;
            default:
                return null;
        }
    };

    const renderHint = () => {
        return null;
        return (
            <div className={`${settingsFieldBaseClass}__hint`}>
                <Hint
                    hint={hint}
                ></Hint>
            </div>
        )
    }

    const renderInputBox = () => {
        return (
            <div className={getInputBoxClass()}>
                <label className={`${settingsFieldBaseClass}__label`} htmlFor={name}>{label}</label>
                <div className={`${settingsFieldBaseClass}__input`}>{renderInput()}</div>
            </div>
        );
    };

    return (
        <div className={getInputFieldClass()}>
            {renderHint()}
            {renderInputBox()}
        </div>
    );
}));

export default SettingsField;



